import { getCachedConversationMessages } from './mcpchat.cache';

export const getters = {
  getChatState(state) {
    return state.chatState;
  },
  getMessages(state) {
    return state.conversationVersion >= 0
      ? getCachedConversationMessages(state.conversationId)
      : [];
  },
  getConversationId(state) {
    return state.conversationId;
  },
  isLoading(state) {
    return state.isLoading;
  },
  getLoadingProgressMessages(state) {
    return state.loadingProgressMessages;
  },
  getHistoryItems(state) {
    return state.historyItems;
  },
  isHistoryOpen(state) {
    return state.isHistoryOpen;
  },
  isHistoryLoading(state) {
    return state.isHistoryLoading;
  },
  isHistoryLoadingMore(state) {
    return state.isHistoryLoadingMore;
  },
  hasMoreHistory(state) {
    return state.hasMoreHistory;
  },
  hasMessages(state) {
    return (
      state.conversationVersion >= 0 &&
      getCachedConversationMessages(state.conversationId).length > 0
    );
  },
  getError(state) {
    return state.error;
  },
  getRequestVersion(state) {
    return state.requestVersion;
  },
  getConversationVersion(state) {
    return state.conversationVersion;
  },
  getSuggestionPrompts(state) {
    return state.suggestionPrompts;
  },
  isSuggestionPromptsLoaded(state) {
    return state.isSuggestionPromptsLoaded;
  },
};
